import rootReducer from "./rootReducer";
import { configureStore } from '@reduxjs/toolkit';
// Example of the `endpoint` you want to use
const endpoint = process.env.REACT_APP_API_URL;

// Configure your store and pass `endpoint` as part of the `extraArgument`
const store = configureStore({
  reducer: 
    rootReducer
  ,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: { endpoint }  // Pass `endpoint` as extraArgument
      }
    })
});
 export default store